import { Context, ContextMembership } from "./context.data";

export class Dog {
    public context: Context|ContextMembership|undefined = undefined

    public identifier: string|undefined = undefined
    public contextId: string|undefined = undefined
    public name: string|undefined = undefined
    public breed: string|undefined = undefined
    public leaderUserId: string|undefined = undefined
    public leaderName: string|undefined = undefined
    public assignments: string[]|undefined = undefined
    public createdByUserId: string|undefined = undefined
    public createdByUserName: string|undefined = undefined
    public updateTimestamp: Date|undefined = undefined
    public creationDate: Date|undefined = undefined
    constructor(
        context?: Context|ContextMembership
    ) {
        this.context = context
    }

    setFromAny(element: any) {
        const {
            creationDate, updateTimestamp,contextId, createdByUserId, createdByUserName,
            identifier, name, breed, leaderUserId, leaderName, assignments, 
        } = element

        this.identifier = identifier ? identifier : this.identifier
        this.contextId = contextId ? contextId : this.contextId
        this.name = name ? name : this.name
        this.breed = breed ? breed : this.breed
        this.leaderUserId = leaderUserId ? leaderUserId : this.leaderUserId
        this.leaderName = leaderName ? leaderName : this.leaderName
        this.assignments = assignments ? assignments : this.assignments
        this.createdByUserId = createdByUserId ? createdByUserId : this.createdByUserId
        this.createdByUserName = createdByUserName ? createdByUserName : this.createdByUserName
        this.updateTimestamp = updateTimestamp ? updateTimestamp : this.updateTimestamp
        this.creationDate = creationDate ? creationDate : this.creationDate
    }


    searchFilter(filter:any) {
        const str = `${this.name}${this.breed}${this.leaderName}${this.createdByUserName}`.toLowerCase();
        return str.includes(filter);
    }

    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key 
     */
    replacerFn(key: string) {
        const list = ["context"]
        if (list.includes(key)) return false
        else return true
    }

}